module.exports = __webpack_public_path__ + "img/png_wgzl_3@2x.b44336de.png";